module.exports = __webpack_public_path__ + "static/media/call_black.a53ba61d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/call_black.svg
// module id = 1270
// module chunks = 0